// extracted by mini-css-extract-plugin
export var backPanel = "index-module--backPanel--03726";
export var buttons = "index-module--buttons--10eec";
export var closeBtn = "index-module--closeBtn--37317";
export var frontPanel = "index-module--frontPanel--e0660";
export var frontPanelBg = "index-module--frontPanelBg--a30e4";
export var frontPanelBody = "index-module--frontPanelBody--68b82";
export var head = "index-module--head--8dd87";
export var headRight = "index-module--headRight--ef120";
export var hideLoading = "index-module--hideLoading--537b4";
export var infoLogo = "index-module--infoLogo--44f6c";
export var infoText = "index-module--infoText--65e5e";
export var isReady = "index-module--isReady--76cb9";
export var light = "index-module--light--a3543";
export var lightAnimation = "index-module--light-animation--b8730";
export var logo = "index-module--logo--c72e5";
export var mic = "index-module--mic--4da81";
export var mobileLayoutContainer = "index-module--mobileLayoutContainer--e3966";
export var mobileLayoutFullscreen = "index-module--mobileLayoutFullscreen--40593";
export var mobileLayoutLoading = "index-module--mobileLayoutLoading--664c0";
export var screen = "index-module--screen--347e0";
export var statusLight = "index-module--statusLight--24cf1";
export var topPlaceholder = "index-module--topPlaceholder--317cd";